
import { QuestionBase, QuestionUITypes } from './question-base';
import { QuestionRow } from './question-row';

export class QuestionPage extends QuestionRow {
    public childrenInRow = false;
    public questionType: QuestionUITypes = QuestionUITypes.ROW;

    constructor(
      key: string,
      private displayText: string,
    ){
      super(key);
    }
}


// WEBPACK FOOTER //
// ./src/app/question-page.ts